<template lang="html">
	<div class="location">
		<div class="input-group" @click="showModal = true">
			<input
				type="text"
				class="form-control"
				:placeholder="placeholder || 'Select Location'"
				:value="selectedModel.address"
				disabled
			/>
			<span class="separator"></span>

			<div class="input-group-append">
				<span class="input-group-text">
					<i class="fa fa-map-marker-alt"></i>
				</span>
			</div>
		</div>

		<Modal type="simple" :show="showModal" @close="showModal = false">
			<template slot="content">
				<div class="modal-content">
					<div class="modal-title">
						<button
							class="close"
							@click="showModal = false"
							aria-label="Close"
						>
							<span>&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<Select
							v-model="address"
							clearable
							filterable
							remote
							:remote-method="queryLocation"
							:loading="loading"
							placeholder="Enter Location to search"
							@on-change="selectMapLocation"
						>
							<Option
								v-for="(location, index) in locations"
								:value="location"
								:key="index"
							>
								{{ location }}
							</Option>
						</Select>

						<div :id="name" class="mapLocation"></div>
					</div>
					<div class="modal-foot">
						<div class="btn btn-primary" @click="locationSelected">
							Select
						</div>
					</div>
				</div>
			</template>
		</Modal>
	</div>
</template>

<script>
export default {
	components: {
		Modal: () => import('./modal'),
		Select: () => import('./select/select'),
		Option: () => import('./select/option'),
	},
	props: {
		name: {
			type: String,
			default: 'location',
		},
		model: {
			default: function () {
				return {
					address: '',
					location: {},
				};
			},
		},
		placeholder: {
			default: undefined,
		},
	},
	data() {
		return {
			selectedModel: {},
			showModal: false,
			loading: false,
			address: '',
			locations: [],
			geocoder: {},
			infowindow: new google.maps.InfoWindow(),
			map: null,
			mapOptions: null,
			selectedLocation: {},
		};
	},
	methods: {
		updateSelf(model) {
			this.$emit('input', model);
		},
		markerInteraction(marker) {
			let $this = this;

			google.maps.event.addListener(marker, 'dragend', function (event) {
				$this.selectedLocation = {
					lat: this.getPosition().lat(),
					lng: this.getPosition().lng(),
				};
				$this.infowindow.setContent('Marker set to the new location');
			});

			// $this.infowindow.setContent(results[0].formatted_address);
			$this.infowindow.setContent('Drag marker to the specific location');
			$this.infowindow.open($this.map, marker);
		},
		selectMapLocation() {
			let $this = this;
			if (this.address === undefined || this.address === '') {
				return;
			}

			this.map = new google.maps.Map(
				document.getElementById(this.name),
				this.mapOptions,
			);
			this.geocoder.geocode(
				{ address: $this.address },
				function (results, status) {
					if (status === 'OK') {
						if (results[0]) {
							$this.map.setZoom(11);
							let marker = new google.maps.Marker({
								draggable: true,
								animation: google.maps.Animation.BOUNCE,
								position: results[0].geometry.location,
								map: $this.map,
							});

							$this.markerInteraction(marker);
							$this.selectedLocation = {
								lat: results[0].geometry.location.lat(),
								lng: results[0].geometry.location.lng(),
							};
							$this.map.setCenter(results[0].geometry.location);
						} else {
							$notify(
								'warning',
								'Results Not Found',
								`The results for ${this.address} could not be found`,
							);
						}
					} else {
						$notify(
							'error',
							'Geo-Codder Fail',
							`An Error occurred with the geo-codder, try again later.`,
						);
					}
				},
			);
		},
		queryLocation(query) {
			let $this = this;
			this.loading = true;
			let displaySuggestions = function (predictions, status) {
				if (status != google.maps.places.PlacesServiceStatus.OK) {
					return;
				}

				$this.loading = false;
				$this.locations = predictions.map((loc) => {
					return loc.description;
				});
			};

			let service = new google.maps.places.AutocompleteService();
			if (query !== '') {
				service.getQueryPredictions(
					{ input: query },
					displaySuggestions,
				);
			}
		},
		locationSelected() {
			if (this.address !== undefined && this.address !== '') {
				this.selectedModel.location = {
					lat: this.selectedLocation,
					lng: this.selectedLocation,
				};
				this.selectedModel.address = this.address;
				this.updateSelf(this.selectedModel);
				this.showModal = false;
			} else {
				$notify(
					'warning',
					'Select Location',
					'Find a location on the map.',
				);
			}
		},
	},
	mounted() {
		setTimeout(() => {
			if (
				this.model.location &&
				this.model.location.lat &&
				this.model.location.lng
			) {
				this.selectedLocation = this.model.location;
			} else {
				this.selectedLocation = { lat: -1.326368, lng: 36.848483 };
			}

			if (this.model.address) {
				this.address = this.model.address;
			}
			this.selectedModel.location = this.selectedLocation;
			this.selectedModel.address = this.address;

			this.geocoder = new google.maps.Geocoder();
			this.mapOptions = {
				zoom: 9,
				controlSize: 22,
				center: this.selectedLocation,
				styles: utils.getMapStyles(),
			};
			this.map = new google.maps.Map(
				document.getElementById(this.name),
				this.mapOptions,
			);

			let marker = new google.maps.Marker({
				draggable: true,
				animation: google.maps.Animation.BOUNCE,
				position: this.selectedLocation,
				map: this.map,
			});

			this.markerInteraction(marker);
		}, 1000);
	},
};
</script>
